<script setup lang="ts">

</script>

<template>
  <h1>SharpenSkills</h1>
</template>

<style scoped>

</style>